<script>
import Card from '@/online_booking/new/components/common/Card';
import GoogleAnalyticsEvents from 'Modules/GoogleAnalytics/resources/assets/js/GoogleAnalyticsEvents'

export default {

    data() {
        return {
            giftcard: null,
            client: null
        }
    },

    mounted() {
        this.$event_bus.$on('finish', ({ client, giftcard }) => {
            this.client = client;
            this.giftcard = giftcard;

            if (this.giftcard && this.giftcard.price_with_vat_formatted) {
                GoogleAnalyticsEvents.GiftcardPurchased.send({
                    'event_category': system_name,
                    'event_label': this.giftcard.name,
                    'value': parseFloat(this.giftcard.price_with_vat_formatted),
                    'send_to': 'clientTracker',
                });
            }
        });
    },

    beforeUnmount() {
        this.$event_bus.$off('finish');
    },

    components: {
        Card,
    },
};

</script>


<template id="booking-success">
    <div v-if="giftcard" id="booking-success-panel">
        <div class="row">
            <div class="col-xs-12">
                <card class="rounded-lg" id="booking-success-booking">
                    <div class="row">
                        <div class="col-xs-12 text-center m-t-40 m-b-30">
                            <i class="zmdi zmdi-check-circle booking-success-icon"></i>

                            <h3>{{ trans('giftcards.purchasing.purchase_complete_header') }}</h3>

                            <h5 class="m-b-30" style="line-height: 25px;">
                                <span v-if="client.email !== ''">{{ trans('vouchers.client_purchase_email', { email: client.email}) }}</span>
                            </h5>

                            <a :href="giftcard.public_url" target="_blank" class="btn btn-custom">
                                {{ trans('giftcards.purchasing.view_giftcard_link') }}
                                <i class="fa fa-external-link m-l-5"></i>
                            </a>
                        </div>
                    </div>
                </card>
            </div>
        </div>
    </div>
</template>
